import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

import TagManager from 'react-gtm-module';
import { useSelector } from 'react-redux';
import { selectProfile } from 'store/profile/selectors';
import { selectIsAuthenticated } from 'store/app/selectors';

// styles
import {
  Wrapper,
  ModalContainer,
  ModalOverlay,
  ModalMenu,
  ModalMenuItem,
  ModalMenuItemChildren,
  ModalMenuItemChildrenLink,
  LogoOuter,
  Link,
} from './styles';

import { menu } from '../../../config/menu';

import { findLocationPath } from '../../../utils/findLocationPath';

import Logo from '../../../assets/images/GI-Cancer-Expert.png';

interface IProps {
  open: boolean;
  close: () => void;
}

export function NavMenu({ open, close }: IProps) {
  const [activeSlide, setActiveSlide] = useState<string | null>(null);
  const [pageTitle, setPageTitle] = useState<string | null>(null);

  // locales hook
  const { t } = useTranslation();

  // selector
  const profileInfo = useSelector(selectProfile);
  const isLoggedIn = useSelector(selectIsAuthenticated);

  // location hook
  const location = useLocation();

  useEffect(() => {
    if (location.pathname) {
      const path = findLocationPath(location.pathname);

      if (!location.pathname.includes('/auth')) {
        setPageTitle(path);
      }
    }

    close();
  }, [location]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 1280) close();
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // @ts-ignore
  return (
    <Wrapper open={open}>
      <ModalContainer open={open}>
        <Link to={'/'}>
          <LogoOuter>
            <img src={Logo} alt="logo" style={{ height: 20 }} />
          </LogoOuter>
        </Link>
        <ModalMenu>
          {menu.map(item => (
            <div key={item.name}>
              {item.name === 'main' ? (
                <Link to={item.slug || ''}>
                  <ModalMenuItem category active={activeSlide === item.name}>
                    {t(translations.nav[item.name])}
                  </ModalMenuItem>
                </Link>
              ) : (
                <Link to={item.slug || ''}>
                  <ModalMenuItem
                    category
                    active={item.slug === location.pathname}
                  >
                    {t(translations.nav[item.name])}
                  </ModalMenuItem>
                </Link>
              )}

              {item && item.hasOwnProperty('submenu') && item.name !== 'main' && (
                <ModalMenuItemChildren
                  length={item['submenu'].length}
                  active={true}
                >
                  {item['submenu'].map(sub => (
                    <Link
                      key={sub.name}
                      to={sub.slug}
                      onClick={() => {
                        if (isLoggedIn && profileInfo?.data?.id) {
                          const tagManagerArgs = {
                            gtmId: process.env.REACT_APP_GTM_ID,
                            dataLayer: {
                              event: 'menu_header_click', //Статическое значение.
                              category: 'Menu Header Click', //Статическое значение
                              action: t(translations.nav[item.name]), //Название раздела меню (верхний уровень) к которому принадлежит пункт меню.
                              label: t(translations.nav[sub.name]), //Название пункта меню, по которому кликнул пользователь.
                              uid: profileInfo?.data?.id, //User ID. Id зарегистрированного пользователя.
                            },
                          };

                          TagManager.dataLayer(tagManagerArgs);
                        }
                      }}
                    >
                      <ModalMenuItemChildrenLink>
                        {t(translations.nav[sub.name])}
                      </ModalMenuItemChildrenLink>
                    </Link>
                  ))}
                </ModalMenuItemChildren>
              )}
            </div>
          ))}
          <Link
            to={isLoggedIn ? '/profile' : '/login?redirect_to=profile'}
            onClick={() => {
              if (isLoggedIn && profileInfo?.data?.id) {
                const tagManagerArgs = {
                  gtmId: process.env.REACT_APP_GTM_ID,
                  dataLayer: {
                    event: 'menu_header_click', //Статическое значение.
                    category: 'Menu Header Click', //Статическое значение
                    action: 'Особистий кабінет', //Название раздела меню (верхний уровень) к которому принадлежит пункт меню.
                    label: 'Особистий кабінет', //Название пункта меню, по которому кликнул пользователь.
                    uid: profileInfo?.data?.id, //User ID. Id зарегистрированного пользователя.
                  },
                };

                TagManager.dataLayer(tagManagerArgs);
              }
            }}
          >
            <ModalMenuItem category>Особистий кабінет</ModalMenuItem>
          </Link>
        </ModalMenu>
      </ModalContainer>

      <ModalOverlay open={open} onClick={close} />
    </Wrapper>
  );
}

export default NavMenu;
